import { gql } from '@apollo/client';

export const FETCH_ALL_PAPERS = gql`
  query getAllPapers {
    getPapers {
      courseName
      _id
      courseCode
      class
    }
  }
`;

export const REGISTER_STUDENT = gql`
  mutation registerStudent($studentDetails: RegisterStudentInput) {
    registerStudent(studentDetails: $studentDetails) {
      token
    }
  }
`;

export const UPLOAD_SIGNED_RECORDS = gql`
  mutation uploadSignedRecords($records: [SignatureInput]) {
    uploadSignedRecords(records: $records)
  }
`;

export const FETCH_STUDENT_DATA = gql`
  mutation fetchStudentData($indexNumber: String) {
    fetchStudentData(indexNumber: $indexNumber) {
      indexNumber
      name
      registeredPapers {
        _id
        courseName
        courseCode
        class
      }
      papersForStudentClass {
        _id
        courseName
        courseCode
        class
      }
    }
  }
`;
